"use client";

import React, { useEffect, useState } from "react";
import styles from "./bg-parallax.module.scss";
import { useMotionValueEvent, useScroll } from "framer-motion";

type Props = {};

const BgParallax = (props: Props) => {
  const [parallax, setParallax] = useState(0);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setParallax(latest * 0.05);
  });

  return (
    <div
      className={styles.container}
      style={{ transform: `translateY(-${parallax}px)` }}
    />
  );
};

export default BgParallax;
